const getAddressOrderShipement = () => {
  const getter = JSON.parse(window.sessionStorage.getItem("getterAddress"));
  const sender = JSON.parse(window.sessionStorage.getItem("senderAddress"));

  return { getter, sender };
};

export default getAddressOrderShipement;
